module.exports = {
	"Play": "播放",
	"Pause": "暫停",
	"Current Time": "目前時間",
	"Duration Time": "總共時間",
	"Remaining Time": "剩餘時間",
	"Stream Type": "串流類型",
	"LIVE": "直播",
	"Loaded": "載入完畢",
	"Progress": "進度",
	"Fullscreen": "全螢幕",
	"Non-Fullscreen": "退出全螢幕",
	"Mute": "靜音",
	"Unmute": "取消靜音",
	"Playback Rate": " 播放速率",
	"Subtitles": "字幕",
	"subtitles off": "關閉字幕",
	"Captions": "內嵌字幕",
	"captions off": "關閉內嵌字幕",
	"Chapters": "章節",
	"You aborted the media playback": "影片播放已終止",
	"A network error caused the media download to fail part-way.": "網路錯誤導致影片下載失敗。",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "影片因格式不支援或者伺服器或網路的問題無法載入。",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "由於影片檔案損毀或是該影片使用了您的瀏覽器不支援的功能，播放終止。",
	"No compatible source was found for this media.": "無法找到相容此影片的來源。",
	"The media is encrypted and we do not have the keys to decrypt it.": "影片已加密，無法解密。"
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/lang/zh-TW.json
// module id = 269
// module chunks = 86